export const enDefaultTranslations: Record<string, string> = {
  'menu': 'Menu',
  'home': 'Home',
  'back': 'Back',

  'messages': 'Messages',
  'cart': 'Cart',
  'settings': 'Settings',

  'subtitles': 'Subtitles',
  'turn_off_subtitles': 'None',
  'no_subtitles_available': 'No subtitles available',
  'off': 'Off',

  'date': 'Date',
  'description': 'Description',
  'charges': 'Charges',

  'original': 'View translated message',
  'translated': 'View original message',
  'isTranslated': '*translation',
  'download_update': 'Please wait.<br/>Downloading update...',
  'download_retry': 'Retry',
  'download_cancel': 'Cancel',
  'download_available': 'Content update available. Do you want to update now?',
  'auth_sent': 'Authorization request sent.\nPlease wait for confirmation…',
  'auth_pending': 'Authorization pending...',
  'auth_rejected': 'Authorization rejected',
  'request_confirmed': 'Request confirmed. Request #',
  'order_confirmed': 'Order confirmed. Order #',
  'confirmed': 'confirmed',
  'internet_required': 'Internet Connection required',
  'required_field': 'Required field',
  'app_not_supported': 'App not supported',
  'turn_on_miracast_screenshare': 'Turn on Miracast/ScreenShare',
  'now_you_can_connect': 'Now you can connect',

  'openexturl': 'Open URL in browser?',

  'messages_send': 'Send',
  'messages_no_messages': 'No messages',

  'bill_page': 'View bill',
  'bill_total': 'Total',
  'bill_requesting': 'Requesting bill...',
  'bill_error': 'Data unavailable',
  'bill_checkedout': 'Guest checked out',
  'bill_loginreq': 'Authorization required',

  'feedback_sent': 'Feedback sent. Thank you.',
  'feedback_invalidfeedback': 'Invalid feedback',
  'feedback_alreadyanswered': 'Feedback already sent. Thank you.',
  'go_to_feedback': 'Go to feedback form',
  'feedback_dialog_desc':
    'Thank you for staying with us. We appreciate you taking the time to send us the feedback about your stay. Feedbacks help us constantly improve our guests experiences by knowing what we are doing right and what we can work on.',

  'yes': 'yes',
  'no': 'no',
  'add': 'Add',
  'suggestions': 'Suggestions',
  'edit': 'edit',
  'delete': 'delete',
  'approx_time': 'Approximate waiting time',
  'product_is_unavailable_for_selected_time':
    'One of items in your order is beyond working hours. <br /> Please modify your order.',
  'alert': 'Alert',

  'toppings': 'toppings',
  'options': 'options',
  'summary': 'summary',
  'new': 'new',
  'not_placed': 'Not placed orders',
  'placed': 'Placed orders',
  'in_process': 'In process',
  'cancelled': 'cancelled',
  'completed': 'completed',
  'details': 'details',
  'order_details': 'Order Details',
  'cancel_order': 'Cancel Order',
  'repeat_order': 'Repeat Order',
  'create_order': 'Order create',

  'cancellation_order': 'Order cancellation',
  'order_was_cancelled': 'Order was cancelled',

  'order_already_exists': 'A similar order already exists',

  'number_of_persons': 'Number of persons',
  'number_of_cutlery': 'Number of cutlery',
  'pieces_pcs': 'pcs',
  'pieces_pers': 'pers',
  'pieces_h': 'h',

  'select_none': 'None',
  'newmessage': 'New messages',
  'you_have_newmessage': 'You have new messages',

  'shop_add_comment': 'Add a comment to the order',
  'choose_options': 'Choose options',
  'choose_airport': 'Choose Airport',
  'departures': 'Departures',
  'arrivals': 'Arrivals',
  'time': 'Time',
  'flight': 'Flight',
  'destination': 'Destination',
  'gate': 'Gate',
  'status': 'Status',
  'from': 'From',
  'terminal': 'Terminal',
  'change_airport': 'Change Airport',

  'scheduled': 'Scheduled',
  'delayed': 'Delayed',
  'diverted': 'Diverted',
  'canceled': 'Canceled',
  'landed': 'Landed',
  'departed': 'Departed',

  'tv_television': 'Television',
  'tv_nottelevision': 'Information',
  'tv_room': 'Room #',
  'tv_welcome': 'Welcome, ',
  'tv_allchannels': 'All channels',
  'tv_categories': 'Categories',
  'tv_category': 'Category',
  'tv_back': 'Back',

  'vod_title': 'Video on Demand',
  'vod_purchases': 'My Purchases',
  'vod_watch_question': 'Continue watching?',
  'vod_watch_continue': 'Continue',
  'vod_watch_start': 'Start over',

  'tv_channels': 'TV channels',
  'anything_category': 'Any category',
  'anything_language': 'Any language',
  'category_channel': ' Channels category:',
  'language_channel': ' Channels language:',
  'navigation': 'Navigation',
  'navigate': 'Navigate',
  'choose_category': 'Choose category',
  'choose_language': ' Choose language',
  'filtering_channel': 'Filter Channels',
  'filtering_channel_by': 'Filter by',
  'by_category': 'by category',
  'by_language': 'by language',
  'by_category_v2': 'category',
  'by_language_v2': 'language',
  'language': ' language',
  'watch_channel': 'Watch Channel',
  'watch': 'Watch',
  'tv_guide': 'TV Guide',
  'jump_to_time': 'Jump to current time',
  'volume': ' Volume',
  'switch_channel': 'Switch channel',
  'switch_language': 'Switch language',
  'anything_male': 'Any',
  'anything_female': 'Any',
  'of': 'of',
  'not_available_channels': 'No channels available.',
  'not_available_content': 'Content is blocked. Please contact reception.',
  'list_is_empty': 'List is empty',
  'channels': 'channels',
  'languages': 'languages',

  'pincode_remember':
    'Please remember this PIN. It will be used for action confirmation.<br>To reset the PIN contact the reception.',

  'parental_lock': 'Parental Lock',
  'parental_lock_enabled': 'Enable',
  'parental_lock_description': 'Confirm each action by entering your PIN',
  'parental_lock_confirm': 'Enter PIN',
  'parental_lock_disable_confirm': 'Enter current PIN to disable Parental Lock',
  'confirm': 'Confirm',

  'listen_radio': 'Listen radio',
  'filtering': 'Filtering',
  'filter': 'Filter',
  'all': 'all',
  'enabled': 'enabled',
  'by_genre': 'by genre',
  'by_genre_v2': 'genre',
  'all_genres': 'All genres',
  'radio_list': 'Radio list',
  'genres': 'Genres',
  'radio_stop_playing': 'Stop playing',
  'downloading': 'Downloading',
  'playing': 'Playing',
  'pause': 'Pause',

  'day': 'day',
  'today': 'Today',
  'tomorrow': 'Tomorrow',
  'monday': 'Monday',
  'tuesday': 'Tuesday',
  'wednesday': 'Wednesday',
  'thursday': 'Thursday',
  'friday': 'Friday',
  'saturday': 'Saturday',
  'sunday': 'Sunday',
  'wind': 'Wind',
  'humidity': 'Humidity',
  'pressure': 'Pressure',
  'cloudiness': 'Cloudiness',
  'wind_direct_n': 'N',
  'wind_direct_ne': 'NE',
  'wind_direct_ene': 'NE',
  'wind_direct_nne': 'NE',

  'wind_direct_e': 'E',
  'wind_direct_se': 'SE',
  'wind_direct_sse': 'SE',
  'wind_direct_ese': 'SE',

  'wind_direct_s': 'S',
  'wind_direct_sw': 'SW',
  'wind_direct_wsw': 'SW',
  'wind_direct_ssw': 'SW',

  'wind_direct_w': 'W',
  'wind_direct_nw': 'NW',
  'wind_direct_nnw': 'NW',
  'wind_direct_wnw': 'NW',

  'wind_direct_full_n': 'North',
  'wind_direct_full_ne': 'North-east',
  'wind_direct_full_nne': 'North-east',
  'wind_direct_full_ene': 'North-east',

  'wind_direct_full_e': 'East',
  'wind_direct_full_se': 'South-east',
  'wind_direct_full_sse': 'South-east',
  'wind_direct_full_ese': 'South-east',

  'wind_direct_full_s': 'South',
  'wind_direct_full_sw': 'South-west',
  'wind_direct_full_ssw': 'South-west',
  'wind_direct_full_wsw': 'South-west',

  'wind_direct_full_w': 'West',
  'wind_direct_full_nw': 'North-west',
  'wind_direct_full_nnw': 'North-west',
  'wind_direct_full_wnw': 'North-west',

  'metr_per_second': 'm/s',
  'miles_per_hour': 'mph',
  'km_per_hour': 'km/h',
  'pressure_dimension': 'mm',
  'pressure_dimension_inhg': 'in',
  'january': 'January',
  'february': 'February',
  'march': 'March',
  'april': 'April',
  'may': 'May',
  'june': 'June',
  'july': 'July',
  'august': 'August',
  'september': 'September',
  'october': 'October',
  'november': 'November',
  'december': 'December',
  'january_short': 'Jan',
  'february_short': 'Feb',
  'march_short': 'Mar',
  'april_short': 'Apr',
  'may_short': 'May',
  'june_short': 'Jun',
  'july_short': 'Jul',
  'august_short': 'Aug',
  'september_short': 'Sep',
  'october_short': 'Oct',
  'november_short': 'Nov',
  'december_short': 'Dec',
  'change_location': 'Change location',
  'change_quantity': 'Change quantity',
  'icon-clear-sky': 'clear sky',
  'icon-broken-clouds': 'broken clouds',
  'icon-few-clouds': 'few clouds',
  'icon-mist': 'mist',
  'icon-rain': 'rain',
  'icon-scattered-clouds': 'scattered clouds',
  'icon-shower-rain': 'shower rain',
  'icon-snow': 'snow',
  'icon-thunderstorm': 'thunderstorm',
  'select_btn': 'Select',

  'sleep_timer': 'Sleep timer',
  'sleep_timer_will_powered_of': 'The TV will be powered off in:',
  'continue_watching_tv': 'Continue watching TV',
  'minutes_short': 'min',
  'in': 'in',

  'select_time_date': 'Select Time & Date',
  'change_time': 'Change Time',
  'wakeup_set_to': 'Your wake-up service is set to',
  'wakeup_cancelled': 'Wake-up cancelled',
  'just_wakeup': 'Wake-up',
  'cancel': 'Cancel',

  'mod_title': 'Genres',
  'mod_number': 'No.',
  'mod_title_audio': 'Title',
  'mod_artist': 'Artist',
  'mod_duration': 'Duration',

  'admission_to_adult': 'Admission to adult content',
  'confirm_your_age':
    '<span class="ui-icon-18plus"></span>This section contains adult content only!<br /> To continue confirm your age.',
  'im_an_adult': 'I am over 18 years old, go to the category',
  'im_a_child': `I'm under 18 years old, go back`,
  'buying_movie': 'You are buying a movie',
  'confirm_sum':
    '<span class="custom_dialog_text_confirm">To confirm the purchase,<br> enter your sum and press enter.</span>',
  'confirm_pin':
    '<span class="custom_dialog_text_confirm">To confirm the purchase,<br> enter your room and press enter.</span>',
  'confirm_room':
    '<span class="custom_dialog_text_confirm">To confirm the purchase,<br> enter your room number and press enter.</span>',

  'viewbill_pay': 'Pay',
  'express_checkout_failed':
    '<span class="custom_dialog_text_confirm">Express checkout unavailable,<br> please contact reception.</span>',
  'express_checkout_retry':
    '<span class="custom_dialog_text_confirm">Express checkout unavailable,<br> please try again.</span>',
  'express_checkout_success':
    '<span class="custom_dialog_text_confirm">Express checkout success, please contact reception for receipt.</span>',

  'guest_name': 'guest',
  'welcome_guest_name': 'Guest',
  'screen_sharing': 'Screen Sharing',

  'wakeup_title': 'Wake up, rise and shine!',
  'wakeup_message':
    'Good Morning, this is your wake-up call. It’s time to begin this wonderful day on the best note – enjoy another delightful morning',

  'not_registered': 'You are not registered, <br> please contact reception',

  'next_programme': 'Next',

  'product_added_header': 'Items have been added',
  'product_added_text': 'You can add other products<br /> or go to your cart and finish order',
  'delivery_time_header': 'Delivery Time',
  'success_product_header': 'Your order is on the way to you',
  'success_product_text':
    'Thank you for your order! <br />You can track the status of your order <br />or cancel it in My Orders section.',
  'success_service_header': 'Request Sent',
  'success_service_text':
    'Thank you for you booking. <br />You can track the status of your booking <br />or cancel it in My Orders section.',
  'confirmation_page_header': 'Final Confirmation',
  'confirmation_page_text': 'Please confirm the order by entering the requested <br />data below',
  'confirmation_page_text_tooltip': 'Please note that the order amount will be charged to your bill',
  'confirmation_page_room_number': 'Your room number:',
  'confirmation_page_pin_code': 'PIN code:',
  'confirmation_page_text_error': 'Data is incorrect. Please try again or ask at reception for help',
  'approximate_time': 'Approximate waiting time',
  'back_to_menu': 'Back to Main Menu',
  'my_orders': 'My orders',
  'your_order': 'Your order',

  'und': 'Undefined',

  'track': 'track',
  'nice_day': 'Have a nice day,<br /> {username}!',

  'night': 'night',

  'dooreye_ask_title': 'Door Eye',
  'dooreye_ask_text': 'Hello! You have a visitor.',
  'dooreye_ask_confirm': 'Show',
  'dooreye_ask_cancel': 'Cancel',
  'dooreye_show_error': 'Check Door Eye and video signal',

  'airstream_fullscreen': 'Full screen',
  'airstream_timeout_text': 'Are you still watching?<br>Session will be stopped in {timer} sec',
  'airstream_title': 'AirPlay',
  'airstream_text': "Wirelessly send what's on your iOS device or computer to this display using AirPlay",
  'airstream_instruction_title': 'HOW TO SET UP?',
  'airstream_instruction_text':
    '<ol><li>Choose Wi-Fi Network <div id="airstream_wifi_name"></div></li><li id="airstream_qrauth">Scan this QR Code with your smartphone camera app<br></li><li>Choose this Apple TV <div id="airstream_device_name"></div></li></ol>',
  'chromestream_title': 'ChromeCast',
  'chromestream_text': "Wirelessly send what's on your mobile device or computer to this display using ChromeCast",
  'chromestream_instruction_title': 'HOW TO SET UP?',
  'chromestream_instruction_text':
    '<ol><li>Choose Wi-Fi Network <div id="chromestream_wifi_name"></div></li><li id="chromestream_qrauth">Scan this QR Code with your smartphone camera app<br></li><li>Choose this ChromeCast device <div id="chromestream_device_name"></div></li></ol>',

  'chromecast_title': 'ChromeCast',
  'chromecast_text': "Wirelessly send what's on your mobile device or computer to this display using ChromeCast",
  'chromecast_instruction_title': 'HOW TO SET UP?',
  'chromecast_instruction_text':
    '<ol><li>Choose Wi-Fi Network <div id="chromecast_wifi_name"></div></li><li id="chromecast_qrauth">Scan this QR Code with your smartphone camera app<br></li><li>Choose this ChromeCast device <div id="chromecast_device_name"></div></li><li>Press OK on the remote after scanning</li></ol>',
  'chromecast_fullscreen': 'Full screen',

  'google_cast_builtin_title': 'GoogleCast',
  'google_cast_builtin_text': "Wirelessly send what's on your mobile or computer to this display using GoogleCast",
  'google_cast_builtin_instruction_title': 'HOW TO SET UP?',
  'google_cast_builtin_instruction_text':
    '<ol><li>Choose Wi-Fi Network <div id="google_cast_builtin_wifi_name"></div></li><li id="google_cast_builtin_qrauth">Scan this QR Code with your smartphone camera app<br></li><li>Open the app (YouTube, Netflix, etc.), look for the device named <div id="google_cast_builtin_device_name" style="display: inline;"></div></li></ol>',

  'airplay_builtin_title': 'AirPlay',
  'airplay_builtin_text': "Wirelessly send what's on your mobile or computer to this display using GoogleCast",
  'airplay_builtin_instruction_title': 'HOW TO SET UP?',
  'airplay_builtin_instruction_text':
    '<ol><li>Choose Wi-Fi Network <div id="google_cast_builtin_wifi_name"></div></li><li id="google_cast_builtin_qrauth">Scan this QR Code with your smartphone camera app<br></li><li>Open the app (YouTube, Netflix, etc.), look for the device named <div id="google_cast_builtin_device_name" style="display: inline;"></div></li></ol>',

  'Inspiration_Morning': 'Inspiration Morning',
  'Birds_in_a_Forest': 'Birds in a Forest',
  'Morning_Touch': 'Morning Touch',
  'Brand_New_Day': 'Brand New Day',
  'Summer_Jump': 'Summer Jump',

  'tv_switch_off_info': 'TV will switch off in {{data}} minutes',

  'read': 'Read',

  'yandex_station_notyet': 'Not yet activated',
  'yandex_station_continue': 'Continue',

  'auto_poweroff_timeout_text': 'Are you still watching?<br>TV will power off in {timer} sec',
  'fullscreen_language_btn': 'Language',

  'disney-existing-subscriber': 'Existing Subscriber',
  'disney-enjoy-to-add': 'Enjoy Disney+ on us',
  'disney-logout-list-title': 'Privacy',
  'disney-logout-list-item-title': 'Log out',
  'disney-trial-page-title': 'Enjoy Disney+ on us during your stay',
  'disney-trial-page-content':
    '<div class="disney-list">1</div>' +
    '<p>Connect your personal device to the hotel Wi-Fi</p>' +
    '<div class="disney-list">2</div>' +
    '<div class="disney-qr-container">' +
    '<div class="disney-qr-left">' +
    '<div class="disney-qr-description">Scan the following QR code with your personal device.</div>' +
    '<div id="disney-trial-qr"></div>' +
    '</div>' +
    '<div class="disney-or-button">or</div>' +
    '<div class="disney-qr-right">' +
    '<div class="disney-qr-right-text">' +
    'Type <span id="disney-trial-site"></span> on the web browser of your personal device' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<br />' +
    '<div class="disney-list">3</div>' +
    '<p>The Disney+ will show on your personal device.' +
    '<br />Follow the account creation steps before selecting the next step.</p>' +
    '<div class="disney-list">4</div>' +
    '<p>Once you have created your account: press <span class="disney-circle-button">OK</span> on the remote control, follow the instructions on your personal device and TV screen to display your account</p>',
  'disney-logout-page-title': 'You are about to log out apps from this TV',
  'disney-logout-page-content':
    '<p>Press <span class="circle-button">OK</span> on your remote control to confirm and return to the main menu <br><span class="disney-sub-info">This action will restart the TV during ~30 seconds.</span></p><br><p>You will need to log back in to access APPS</p><br><p>Press <span class="rectangle-button">BACK</span> to cancel this request and return to the main menu without any action</p>',
  'disney-please-check-in':
    "Please Check in. <br /><br />Thank you for staying at Disney's Holywood Hotel<br /><br />Have a magical day!",

  'googlecast_connect_description':
    'Connect your device to this TV to cast anytime during your stay. Your device stays connected until you check out.',
  'googlecast_settings_description':
    'By connecting, you agree to the Google Terms of Service. Google collects usage data and crash reports to help improve Cast. You can turn this off, as well as review the terms and Google Privacy Policy, in Cast settings.',
  'googlecast_settings_button': 'Cast settings',
  'googlecast_qr_code_text': 'On your mobile device, scan this QR code to get started',
  'googlecast_connect_without_qr': 'Connect without QR code',
  'googlecast_scan_qr_instead': 'Scan QR code instead',
  'googlecast_help_text': "For questions or troubleshooting, please contact the hotel's front desk.",
  'googlecast_step1_connect_wifi': 'Connect your other device to Wi-Fi',
  'googlecast_step2_password': 'Password',
  'googlecast_step2_visit_website': 'Scan QR code or visit ',
  'googlecast_step2_scan_qr_code': 'Scan QR code',
  'googlecast_step3_enter_room_pin': 'Enter this PIN',
  'googlecast_ready_to_cast': 'You\'re ready to <br>start casting',
  'googlecast_on_your_other_device': 'On your other device',
  'googlecast_open_your_favorite_app': 'Open your favorite media app',
  'googlecast_tap_google_cast': 'Tap Google Cast',
  'googlecast_in_the_list': 'in the list',
  'done': 'Done',
};
